import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { festiveCardSx, colors } from "./constants";

/**
 * SuccessCard — 领取成功状态卡片
 *
 * @param {string|null} claimedAt   - ISO 时间字符串，领取时间
 * @param {string}      message     - 来自 API 的成功消息
 * @param {string}      rewardLabel - 突出展示的奖励文字，例如 "+200MB 存储空间"
 * @param {string}      footerHint  - 底部提示语
 */
export function SuccessCard({ claimedAt, message, rewardLabel, footerHint }) {
  const dateStr = claimedAt
    ? new Date(claimedAt).toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : null;

  return (
    <Paper
      elevation={0}
      sx={{
        ...festiveCardSx,
        maxWidth: 440,
        width: "100%",
        p: { xs: 3, sm: 4 },
        textAlign: "center",
        zIndex: 2,
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 72, color: colors.gold, mb: 2 }} />
      <Typography
        variant="h5"
        fontWeight={800}
        gutterBottom
        sx={{ color: colors.ivory }}
      >
        已领取过，不可重复领取
      </Typography>
      {message && (
        <Typography sx={{ color: "rgba(255, 248, 231, 0.84)", mb: 1.2 }}>
          {message}
        </Typography>
      )}
      {rewardLabel && (
        <Typography
          variant="body2"
          sx={{
            color: colors.gold,
            fontWeight: 800,
            fontSize: "1.5rem",
            my: 2,
            textShadow: "0 0 18px rgba(255, 209, 102, 0.28)",
          }}
        >
          {rewardLabel}
        </Typography>
      )}
      {dateStr && (
        <Typography variant="caption" sx={{ color: "rgba(255, 248, 231, 0.7)" }}>
          领取时间：{dateStr}
        </Typography>
      )}
      {footerHint && (
        <Typography
          variant="body2"
          sx={{ color: "rgba(255, 248, 231, 0.76)", mt: 2, fontSize: "0.86rem" }}
        >
          {footerHint}
        </Typography>
      )}
    </Paper>
  );
}
